/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AddColumnRight({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#AddColumnRight_svg__a)"><path fillRule="evenodd" d="M2.75.9a2.6 2.6 0 0 0-2.6 2.6v9a2.6 2.6 0 0 0 2.6 2.6h5.5a.6.6 0 1 0 0-1.2h-.9V2.1h.9a.6.6 0 1 0 0-1.2h-5.5Zm3.4 1.2h-3.4a1.4 1.4 0 0 0-1.4 1.4v9a1.4 1.4 0 0 0 1.4 1.4h3.4V2.1Z" clipRule="evenodd" /><path d="M12.5 4.9a.6.6 0 0 1 .6.6v1.9H15a.6.6 0 1 1 0 1.2h-1.9v1.9a.6.6 0 1 1-1.2 0V8.6H10a.6.6 0 0 1 0-1.2h1.9V5.5a.6.6 0 0 1 .6-.6ZM9.9 1.5a.6.6 0 0 1 .6-.6h1a1.6 1.6 0 0 1 1.6 1.6V3a.6.6 0 1 1-1.2 0v-.5a.4.4 0 0 0-.4-.4h-1a.6.6 0 0 1-.6-.6ZM13.1 13a.6.6 0 0 0-1.2 0v.5a.4.4 0 0 1-.4.4h-1a.6.6 0 0 0 0 1.2h1a1.6 1.6 0 0 0 1.6-1.6V13Z" /></g><defs><clipPath id="AddColumnRight_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;